module.exports = __webpack_public_path__ + "img/luxury-3.16e5a7a7.png";